import React, { createContext, useState, useContext, ReactNode } from 'react';
import ModalMessageError from '../../components/modal/modalMessageError';

type ErrorContextType = {
    showError: (message: string) => void;
    clearError: (index: number) => void;
};

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

type ErrorProviderProps = {
    children: ReactNode;
};

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
    const [errors, setErrors] = useState<string[]>([]);  // Liste des erreurs en file

    // Ajouter une erreur à la liste
    const showError = (message: string) => {
        setErrors(prevErrors => [...prevErrors, message]);
    };

    // Supprimer une erreur spécifique de la liste
    const clearError = (index: number) => {
        setErrors(prevErrors => prevErrors.filter((_, i) => i !== index));
    };

    return (
        <ErrorContext.Provider value={{ showError, clearError }}>
            {children}
            {/* Afficher les erreurs */}
            {errors.map((error, index) => (
                <ModalMessageError
                    key={index}
                    modalMessage={error}
                    onClose={() => clearError(index)} // Appeler `clearError` pour fermer l'erreur
                />
            ))}
        </ErrorContext.Provider>
    );
};

// Hook pour utiliser le contexte d'erreurs
export const useError = () => {
    const context = useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
};
